import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Vision() {
  const titleAnim = useScrollAnimation();
  const leftColAnim = useScrollAnimation({ rootMargin: '0px 0px -80px 0px' });
  const rightColAnim = useScrollAnimation({ rootMargin: '0px 0px -80px 0px' });
  const bottomAnim = useScrollAnimation({ rootMargin: '0px 0px -60px 0px' });

  return (
    <section id="vision" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={titleAnim.ref}
          className={titleAnim.isVisible ? 'anim-fade-up' : 'anim-hidden'}
        >
          <div className="mb-8 md:mb-12">
            <div className="flex items-center gap-3 mb-3 md:mb-4">
              <img
                src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/758ef2cf37f252b690d6ec189d9cae34.png"
                alt=""
                className="h-6 md:h-8"
              />
              <h2 className="text-3xl md:text-5xl font-black text-gray-900">
                企業の<span className="text-teal-500">思い</span>
              </h2>
            </div>
            <p className="text-xs md:text-sm text-gray-500 tracking-widest">
              Company Vision
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-start mb-10 md:mb-16">
          <div
            ref={leftColAnim.ref}
            className={leftColAnim.isVisible ? 'anim-fade-left' : 'anim-hidden'}
          >
            <h3 className="text-2xl md:text-4xl font-bold text-gray-900 mb-6 md:mb-8 leading-relaxed">
              物流の現場には、<br className="hidden md:block" />
              社会を<span className="text-teal-500">動かす</span><br className="hidden md:block" />
              大きな力があります。
            </h3>
            <p className="text-sm md:text-base leading-relaxed text-gray-700 mb-4 md:mb-6">
              私たちの暮らしを支える&quot;エッセンシャルワーク&quot;のひとつに、運送業があります。
            </p>
            <p className="text-sm md:text-base leading-relaxed text-gray-700 mb-6 md:mb-8">
              日々の暮らしに欠かせない物流の現場には、社会を動かす大きな力があります。
            </p>
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden shadow-lg">
              <img
                src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/af74c03209d5dcf53b2cd5568c6bc349.png"
                alt="倉庫作業"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div
            ref={rightColAnim.ref}
            className={rightColAnim.isVisible ? 'anim-fade-right anim-delay-200' : 'anim-hidden'}
          >
            <p className="text-sm md:text-base leading-relaxed text-gray-700 mb-6 md:mb-8">
              私たちは「働きがい」が「人を幸せ」にすると、専門家が招える営農と改善に向き合ってきました。
              <br />
              <br />
              だからこそ【今できること】を大切にし、<br />
              一歩ずつ確実に前へ進んでいきます。
            </p>
            <div className="relative w-full aspect-[3/4] md:aspect-[3/4] rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/6e16ffe165c2df75e0dd291f9f7786d0.jpeg"
                alt="物流作業"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>

        <div
          ref={bottomAnim.ref}
          className={bottomAnim.isVisible ? 'anim-scale-in' : 'anim-hidden'}
        >
          <div className="relative bg-gradient-to-b from-gray-50 to-white rounded-xl md:rounded-2xl p-6 md:p-12">
            <div className="absolute top-0 right-0 w-32 h-32 md:w-64 md:h-64 opacity-5">
              <img
                src="https://storage.readdy-site.link/project_files/1dabbddb-19db-4cfd-9ba9-9c36e919f8d4/66335635-626c-4808-83ab-9757628e0a4f_unnamed.png?v=2e617b8710e10fa2e4d8dacb5eacbdef"
                alt=""
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-xl sm:text-2xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6 leading-relaxed relative z-10">
              安全・丁寧・確実な業務を支えるのは、<br className="hidden sm:block" />
              現場で日々努力を重ねる<br className="hidden sm:block" />
              社員<span className="text-teal-500">一人ひとり</span>の力です。
            </h3>
            <p className="text-sm md:text-base leading-relaxed text-gray-700 relative z-10">
              その情熱と誇りこそ、お客様との信頼を生み、地域の暮らしを支えています。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
